// third-party
import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storageSession from 'redux-persist/lib/storage/session';

// THEME project import - THESE WILL GO AWAY
import menu from './menu/menu';
import snackbar from './snackbar/snackbar';
import rootReducer from './root/root.slice';

// ==============================|| COMBINE REDUCERS ||============================== //
const rootPersistConfig = {
  key: 'root',
  storage: storageSession,
  keyPrefix: 'nav-root-',
  blacklist: ['isRootLoading']
};

const reducers = combineReducers({
  root: persistReducer(rootPersistConfig, rootReducer),
  menu,
  snackbar
});

export default reducers;
